import type { SearchCustomersParams } from './customer.api';

export const customerKeys = {
  all: ['customers'] as const,
  detail: (id: string): readonly unknown[] => [...customerKeys.all, 'detail', id] as const,
  list: (params: SearchCustomersParams): readonly unknown[] => [...customerKeys.lists(), params] as const,
  lists: (): readonly unknown[] => [...customerKeys.all, 'list'] as const,
};
